import React from 'react'
import { Typography } from '@material-ui/core'
import pessoaJuridicaRepository from './PessoaJuridicaRepository'
import RequisicaoCard from '../RequisicaoCard'
import { Socios } from './Socios'

const PessoaJuridicaCard = ({ match, cnpj, disabled, validateFieldName }) => {
  const transform = query => ({
    ...query,
    cnpj
  })

  const validateData = data => {
    if (!data) return 'ERROR'

    switch (data.situacaoCadastral) {
      case 'ATIVA':
        return { status: 'SUCCESS', message: '' }
      case 'SUSPENSA':
        return { status: 'WARNING', message: 'Suspensa' }
      case 'INAPTA':
        return { status: 'WARNING', message: 'Inapta' }
      case 'BAIXADA':
        return { status: 'WARNING', message: 'Baixada' }
      default:
        return { status: 'ERROR', message: '' }
    }
  }

  return (
    <RequisicaoCard
      title="Pessoa Jurídica Receita Federal"
      match={match}
      repository={pessoaJuridicaRepository}
      transformManualFetch={transform}
      transformQuery={transform}
      disabled={disabled}
      validData={true}
      validateData={validateData}
      validateFieldName={validateFieldName}
    >
      {data => (
        <>
          {data.situacaoCadastral && (
            <Typography>
              <b>Situação:</b> {data.situacaoCadastral}
            </Typography>
          )}
          {data.nomeEmpresarial && (
            <Typography>
              <b>Razão Social:</b> {data.nomeEmpresarial}
            </Typography>
          )}
          {data.nomeFantasia && (
            <Typography>
              <b>Nome Fantasia:</b> {data.nomeFantasia}
            </Typography>
          )}
          {data.municipio && (
            <Typography>
              <b>Municipio:</b> {data.municipio}
            </Typography>
          )}
          {data.uf && (
            <Typography>
              <b>UF:</b> {data.uf}
            </Typography>
          )}
          {data.logradouro && (
            <Typography>
              <b>Logradouro:</b> {data.logradouro}
            </Typography>
          )}
          {data.numero && (
            <Typography>
              <b>Número:</b> {data.numero}
            </Typography>
          )}
          {data.telefone && (
            <Typography>
              <b>Telefone:</b> {data.telefone}
            </Typography>
          )}
          {data.capitalSocial && (
            <Typography>
              <b>Capital Social:</b> {data.capitalSocial}
            </Typography>
          )}
          {data.dataAbertura && (
            <Typography>
              <b>Data Abertura:</b>{' '}
              {data.dataAbertura}
            </Typography>
          )}
          {data.pessoaJuridicaRfSocios?.length && (
            <Socios 
              socios={data.pessoaJuridicaRfSocios}
            />
          )}
        </>
      )}
    </RequisicaoCard>
  )
}

export default React.memo(PessoaJuridicaCard)
